// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","cell":"cell-14hOB","wrapper":"wrapper-2W91E","value":"value-3vuQU","code":"code-1rRev","wrapper_alternative":"wrapper_alternative-1PfCo"};